// extracted by mini-css-extract-plugin
export default {"prompt":"PrintPrompt_prompt__51wwo","heading":"PrintPrompt_heading__nVo1+","headingIcon":"PrintPrompt_headingIcon__UWYt7"};